module.exports = __webpack_public_path__ + "static/media/logo_icon_signup.98178a37.svg";